import { SIGN_IN, SIGN_UP } from '@chegg-wt/core/constants/nav'
import { NavItem } from '@chegg-wt/core/types/core'

export const WRITING_ASSISTANT_RIGHT_NAV = 'writing-assistant-right-nav'
export const headerAccountItems: NavItem[] = [
  {
    name: SIGN_IN,
    hideOnMobile: true,
  },
  {
    name: SIGN_UP,
    hideOnMobile: true,
  },
]

// TODO: create constants/enum for using route and name.
export const loggedInUserNavOptions: NavItem[] = [
  {
    name: 'Settings',
    icon: 'settings',
    route: 'toProfile',
  },
  {
    name: 'Logout',
    icon: 'logout',
    route: 'toWritingAssistant',
  },
]
